import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './styles/theme.css'
import App from './App.vue'
import router from './router'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { onAuthStateChanged } from 'firebase/auth'
import { auth } from './firebase'

let app

onAuthStateChanged(auth, () => {
  if (!app) {
    app = createApp(App)

    for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
      app.component(key, component)
    }

    app.use(ElementPlus)
    app.use(router)
    app.mount('#app')
  }
})
